import axios from "axios";

export const baseUrl = process.env.REACT_APP_API_BASE;

export const listPdfs = () => axios.get(`${baseUrl}/pdf/list`);
export const generatePdf = (data) => axios.post(`${baseUrl}/pdf/generate`, data);

